import { VNEXT_TAGS } from "../common.js";
import { xCardApi } from "../api.js";
const xCardAlertsApi = xCardApi.injectEndpoints({
  endpoints: (builder) => ({
    getAlertsForFeature: builder.query({
      query: (payload) => {
        return {
          url: `/workspaces/${payload.workspaceId}/feature/${payload.id}/alerts`,
          body: void 0,
          method: "GET",
          params: { includeAutoShutdownAlertsOnly: false, "api-version": "2022-12-01-internal" }
        };
      },
      providesTags: (result, error, { id }) => [{ type: VNEXT_TAGS.XCARD_ALERT, id }]
    }),
    getAlertsForExperiment: builder.query({
      query: (payload) => {
        return {
          url: `/workspaces/${payload.workspaceId}/experiment/${payload.id}/alerts`,
          body: void 0,
          method: "GET",
          params: { includeAutoShutdownAlertsOnly: false, "api-version": "2022-12-01-internal" }
        };
      },
      providesTags: (result, error, { id }) => [{ type: VNEXT_TAGS.XCARD_ALERT, id }]
    })
  })
});
const {
  usePrefetch: useXCardAlertsApiPrefetch,
  useGetAlertsForFeatureQuery,
  useGetAlertsForExperimentQuery
} = xCardAlertsApi;
export {
  useGetAlertsForExperimentQuery,
  useGetAlertsForFeatureQuery,
  useXCardAlertsApiPrefetch,
  xCardAlertsApi
};
//# sourceMappingURL=alert.js.map
